import { EMPTY_ADDRESS_FORM } from '../../../constants';
import { FacilityFormValues } from '../../types';

export const emptyFacilityForm: FacilityFormValues = {
  label: '',
  value: '',
  userAdded: false,
  address: EMPTY_ADDRESS_FORM,
};

export const FACILITY_ROUTES = {
  get: '/facilities/search',
  post: '/facilities',
};
